(() => {
  const initCarousel = (root) => {
    const viewport = root.querySelector('[data-featured-viewport]');
    const track = viewport ? viewport.querySelector('.brands-featured__track') : null;
    const prev = root.querySelector('.brands-featured__button--prev');
    const next = root.querySelector('.brands-featured__button--next');

    if (!viewport || !prev || !next) return;

    const getStep = () => Math.max(viewport.clientWidth * 0.8, 240);
    let minScroll = null;

    const getBounds = () => {
      const maxDelta = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
      if (minScroll === null) minScroll = viewport.scrollLeft;
      return { minScroll, maxScroll: minScroll + maxDelta };
    };

    const syncArrows = () => {
      const x = viewport.scrollLeft;
      if (minScroll === null || x < minScroll) minScroll = x;
      const { minScroll: min, maxScroll: max } = getBounds();

      const canScroll = max - min > 1;
      const canPrev = canScroll && x > min + 1;
      const canNext = canScroll && x < max - 1;

      prev.hidden = !canPrev;
      next.hidden = !canNext;
    };

    prev.hidden = true;
    next.hidden = true;

    const updateVisibility = () => {
      syncArrows();
    };

    prev.addEventListener('click', () => {
      viewport.scrollBy({ left: -getStep(), behavior: 'smooth' });
    });

    next.addEventListener('click', () => {
      viewport.scrollBy({ left: getStep(), behavior: 'smooth' });
    });

    updateVisibility();
    let raf = 0;
    const onScroll = () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(syncArrows);
    };
    viewport.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('load', updateVisibility, { once: true });

    if ('ResizeObserver' in window) {
      const resizeObserver = new ResizeObserver(syncArrows);
      resizeObserver.observe(viewport);
      if (track) resizeObserver.observe(track);
    } else {
      window.addEventListener('resize', updateVisibility);
    }

    syncArrows();
  };

  document.addEventListener('DOMContentLoaded', () => {
    document
      .querySelectorAll('[data-featured-carousel]')
      .forEach((root) => initCarousel(root));
  });
})();
